import React from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Chip from "@mui/material/Chip";
import logo from "./img/logo.gif";
import "photoswipe/dist/photoswipe.css";
import "./website.css";
function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {"Copyright © "}
      <Link color="inherit">Castle Pixel</Link> {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

// TODO remove, this demo shouldn't need to reset the theme.

export default function Website() {
  return (
    <div className="App">
      <main className="main-container">
        {/* Hero unit */}
        <Box
          sx={{
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth="xl" align="center">
            <img
              style={{ marginBottom: "20px", maxWidth: "924px" }}
              className="logo"
              src={logo}
              width="100%"
            ></img>
            <Typography
              variant="h5"
              align="center"
              color="text.secondary"
              paragraph
            >
              Making retro games since 2014
            </Typography>
          </Container>
        </Box>

        <Container>
          <Grid container spacing={2}>
            <Grid item xl={12} md={12} xs={12}>
              <h2 style={{ color: "#f28b46" }}>Cattle Country</h2>
              <div className="embed-container">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/-GV3QQnqGZo?si=NCHOurhu2LYgCZLZ"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
              <div style={{ marginTop: "5px" }}>
                <a
                  href="https://store.steampowered.com/app/2818150/Cattle_Country/"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#1c2939",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Steam
                  </Button>
                </a>
              </div>
            </Grid>
            <Grid item xl={12} md={12} xs={12}>
              <h2 style={{ color: "#f28b46" }}>Blossom Tales 2</h2>
              <div className="embed-container">
                <iframe
                  src="https://www.youtube.com/embed/SQTcL91TA3Y?si=PIz9XI60rWTT-Qdn"
                  title="Blossom Tales 2"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
              <div style={{ marginTop: "5px" }}>
                <a
                  href="https://store.steampowered.com/app/1747830/Blossom_Tales_II_The_Minotaur_Prince/"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#1c2939",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Steam
                  </Button>
                </a>
                <a
                  href="https://www.nintendo.com/us/store/products/blossom-tales-ii-the-minotaur-prince-switch/"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#e60012",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Switch
                  </Button>
                </a>
                <a
                  href="https://www.xbox.com/en-US/games/store/blossom-tales-ii-the-minotaur-prince/9ph9b8q0wmnt"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#107b10",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Xbox
                  </Button>
                </a>
              </div>
            </Grid>
            <Grid item xl={12} md={12} xs={12}>
              <h2 style={{ color: "#a4c763" }}>Blossom Tales 1</h2>
              <div className="embed-container">
                <iframe
                  src="https://www.youtube.com/embed/-W_JXUJ20og?si=-6ITrqGyocMhmQ-a"
                  title="Blossom Tales 1"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
              <div style={{ marginTop: "5px" }}>
                <a
                  href="https://store.steampowered.com/app/446810/Blossom_Tales_The_Sleeping_King/"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#1c2939",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Steam
                  </Button>
                </a>
                <a
                  href="https://www.nintendo.com/us/store/products/blossom-tales-the-sleeping-king-switch/"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#e60012",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Switch
                  </Button>
                </a>
              </div>
            </Grid>
            <Grid item xl={12} md={12} xs={12}>
              <h2 style={{ color: "#d18728" }}>Rex Rocket</h2>
              <div className="embed-container">
                <iframe
                  src="https://www.youtube.com/embed/wE6R0qnEckI?si=LHk1dYMnYrFsJXmf"
                  title="Rex Rocket"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
              </div>
              <div style={{ marginTop: "5px" }}>
                <a
                  href="https://store.steampowered.com/app/288020/Rex_Rocket/"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#1c2939",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Steam
                  </Button>
                </a>
                <a
                  href="https://www.xbox.com/en-US/games/store/rex-rocket/9PBF1CZQ2156"
                  target="_blank"
                  style={{ float: "right" }}
                >
                  <Button
                    style={{
                      float: "left",
                      backgroundColor: "#107b10",
                      marginRight: "5px",
                    }}
                    variant="contained"
                  >
                    Xbox
                  </Button>
                </a>
              </div>
            </Grid>
          </Grid>
        </Container>
      </main>
      {/* Footer */}
      <Box sx={{ bgcolor: "background.paper", p: 6 }} component="footer">
        <Typography
          variant="subtitle1"
          align="center"
          color="text.secondary"
          component="p"
        >
          <div style={{ marginBottom: "15px", marginTop: "75px" }}>
            <a
              href="http://twitter.com/CastlePixel"
              target="_blank"
              class="purpleF"
            >
              <Chip
                style={{
                  color: "white",
                  backgroundColor: "#179cf0",
                  marginRight: "5px",
                  marginLeft: "5px",
                }}
                label="Twitter"
              />
            </a>
            <a
              href="https://www.facebook.com/castlepixel"
              target="_blank"
              class="orangeF"
            >
              <Chip
                style={{
                  color: "white",
                  backgroundColor: "#0863f7",
                  marginRight: "5px",
                  marginLeft: "5px",
                }}
                label="Facebook"
              />
            </a>
            <a href="mailto:hello@castlepixel.com" class="redF">
              <Chip
                style={{
                  color: "white",
                  backgroundColor: "lightGray",
                  marginRight: "5px",
                  marginLeft: "5px",
                }}
                label="Email"
              />
            </a>
          </div>
        </Typography>
        <Copyright />
      </Box>
      {/* End footer */}
    </div>
  );
}
